import {$qsAll} from '../../../@shared/ts/dom';
import {FeatureFlag} from '../../../@type/features';
import {Feature} from '../reducers/environmentReducer';
import {store} from '../store';

export function initCustomOrderMessaging() {
	if (Feature.enabled(FeatureFlag.STORE_SUPPORT_MESSAGE)) {
		store.subscribe(() => {
			renderCustomOrderMessaging();
		});
	}
}

function renderCustomOrderMessaging() {
	const text = Feature.metadata<string>(FeatureFlag.STORE_SUPPORT_MESSAGE, 'text');
	const type = Feature.metadata<string>(FeatureFlag.STORE_SUPPORT_MESSAGE, 'type');

	if (text && type) {
		if (type === 'inline') {
			$qsAll('.pp-custom-order-message-inline').forEach(($el: HTMLElement) => {
				$el.classList.remove('hide');
			});
		} else {
			$qsAll('#pp-custom-order-message-hover', ($el: HTMLElement) => {
				$el.classList.remove('hide');
			});
		}

		const $temp = document.createElement('div');
		$temp.innerHTML = text;
		// Links in the modal can break stuff so always target a new tab.
		$temp.querySelectorAll('a').forEach($a => {
			$a.setAttribute('target', '_blank');
		});

		/**
         * Removes all elements that are not allowed in the custom order message. Mutates the element passed in.
         */
		const cleanSupportMessageHTML = (element: HTMLElement) => {
			const childrenElements = Array.from(element.children);
			for (const child of childrenElements) {
				if (!['A', 'BR', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'P', 'DIV', 'LI', 'UL', 'OL', 'SPAN', 'IMG'].includes(child.tagName)) {
					child.remove();
					continue;
				}

				if (child.children.length > 0) {
					cleanSupportMessageHTML(child as HTMLElement);
				}
			}
		};

		cleanSupportMessageHTML($temp);

		$qsAll('.pp-custom-order-message', ($el: HTMLElement) => {
			$el.innerHTML = $temp.innerHTML;
		});
	} else {
		$qsAll('.pp-custom-order-message-inline').forEach(($el: HTMLElement) => {
			$el.classList.add('hide');
		});
		$qsAll('#pp-custom-order-message-hover', ($el: HTMLElement) => {
			$el.classList.add('hide');
		});
	}
}
